export default __webpack_public_path__ + "static/media/skins-desktop-grid.6990588c.png";